import { render, staticRenderFns } from "./TouHistoryTab.vue?vue&type=template&id=216393b0"
import script from "./TouHistoryTab.vue?vue&type=script&lang=ts"
export * from "./TouHistoryTab.vue?vue&type=script&lang=ts"
import style0 from "./TouHistoryTab.vue?vue&type=style&index=0&id=216393b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports